import { schema } from 'normalizr';

export const amazonProduct = new schema.Entity('amazonProducts');
export const amazonProducts = [amazonProduct];

export const amazonProductCategory = new schema.Entity('amazonProductCategories');
export const amazonProductCategories = [amazonProductCategory];

export const product = new schema.Entity('products');
export const products = [product];

export const productBan = new schema.Entity('productBans');
export const productBans = [productBan];

export const customer = new schema.Entity('customers');
export const customers = [customer];

export const customerOrigin = new schema.Entity('customerOrigins');
export const customerOrigins = [customerOrigin];

export const customerFile = new schema.Entity('customerFiles');
export const customerFiles = [customerFile];

export const cartItem = new schema.Entity('cartItems');
export const cartItems = [cartItem];

export const cart = new schema.Entity('carts');
export const carts = [cart];

export const textMessage = new schema.Entity('textMessages');
export const textMessages = [textMessage];

export const vendor = new schema.Entity('vendors');
export const vendors = [vendor];

export const inventory = new schema.Entity('inventories');
export const inventories = [inventory];

export const inventoryCategory = new schema.Entity('inventoryCategories');
export const inventoryCategories = [inventoryCategory];

export const inventorySource = new schema.Entity('inventorySources');
export const inventorySources = [inventorySource];

export const inventoryItem = new schema.Entity('inventoryItems');
export const inventoryItems = [inventoryItem];

export const inventoryColumn = new schema.Entity('inventoryColumns');
export const inventoryColumns = [inventoryColumn];

export const inventoryFile = new schema.Entity('inventoryFiles');
export const inventoryFiles = [inventoryFile];

export const inventorySheet = new schema.Entity('inventorySheets');
export const inventorySheets = [inventorySheet];

export const mailMessage = new schema.Entity('mailMessages');
export const mailMessages = [mailMessage];

export const wishlistItem = new schema.Entity('wishlistItems');
export const wishlistItems = [wishlistItem];

export const order = new schema.Entity('orders');
export const orders = [order];

export const orderItem = new schema.Entity('orderItems');
export const orderItems = [orderItem];

export const watchList = new schema.Entity('watchLists');
export const watchLists = [watchList];

export const siteNotification = new schema.Entity('siteNotifications');
export const siteNotifications = [siteNotification];

export const filter = new schema.Entity('filters');
export const filters = [filter];

export const vendorProduct = new schema.Entity('vendorProducts');
export const vendorProducts = [vendorProduct];

export const vendorInventoryItem = new schema.Entity('vendorInventoryItems');
export const vendorInventoryItems = [vendorInventoryItem];

export const refreshOperation = new schema.Entity('refreshOperations');
export const refreshOperations = [refreshOperation];

export const refreshTask = new schema.Entity('refreshTasks');
export const refreshTasks = [refreshTask];

export const refreshMessage = new schema.Entity('refreshMessages');
export const refreshMessages = [refreshMessage];

cart.define({
    customer: customer,
    cart_items: [ cartItem ],
});

cartItem.define({
    amazon_product: amazonProduct,
    cart: cart,
});

customer.define({
    origins: customerOrigins,
    files: customerFiles,
});

customerFile.define({
    customer: customer,
});

textMessage.define({
    customers: customers,
});

vendor.define({
    inventories: inventories,
    latest_inventory: inventory,
});

inventory.define({
    category: inventoryCategory,
    files: inventoryFiles,
});

inventoryCategory.define({
    vendor: vendor,
});

inventorySource.define({
    category: inventoryCategory,
});

inventoryFile.define({
    sheets: inventorySheets,
});

inventorySheet.define({
    columns: inventoryColumns,
});

inventoryItem.define({
    vendor_product: vendorProduct,
});

order.define({
    vendor,
});

orderItem.define({
    order,
});

mailMessage.define({
    vendor,
    inventories,
    orders,
});

watchList.define({
    amazon_products: amazonProducts,
});

wishlistItem.define({
    customer: customer,
    amazon_products: amazonProducts,
});

filter.define({
    categories: amazonProductCategories,
    excluded_categories: amazonProductCategories,
});

vendorProduct.define({
    product: product,
    amazon_product: amazonProduct,
});

vendorInventoryItem.define({
    order_items: orderItems,
    product_bans: productBans,
});

refreshOperation.define({
    vendor: vendor,
    tasks: refreshTasks,
});

refreshTask.define({
    messages: refreshMessages,
});
